module.exports = __webpack_public_path__ + "img/3-center.915fa4ef.png";